module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/queuing/queues/queues.component.scss
// module id = ./src/app/components/framework/queuing/queues/queues.component.scss
// module chunks = main